import { useQuery } from "react-query";

import axios from "axios";

import { GEO_CALCULATION_SERVICE_ADDRESS } from "../modals/constants";
import { GeoCalculationsJob } from "../models/GeoCalculations";

export async function getGeoCalculationsJobs() {
  // A failed request throws: an empty list would read as "this org has no jobs".
  const response = await axios.get<GeoCalculationsJob[]>(
    `${GEO_CALCULATION_SERVICE_ADDRESS}/geo-calculation/jobs`
  );

  if (!Array.isArray(response.data)) {
    // API returns 200 with an empty array if there are no jobs
    return [];
  }

  return response.data;
}

// `enabled` is for callers outside the settings pages: this list is the whole
// org's jobs, so a surface that renders for every user has to be able to ask
// for it only when it needs it.
export function useGetGeoCalculationsJobs(options?: { enabled?: boolean }) {
  return useQuery<GeoCalculationsJob[]>(
    "geoCalculations",
    getGeoCalculationsJobs,
    options
  );
}
